import React from "react";

const Caregiver = (props) => {
  return (
    <svg
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9969 6.80292C10.294 6.80292 8.91077 5.41967 8.91077 3.71674C8.91077 2.0138 10.3002 0.630554 11.9969 0.630554C13.6937 0.630554 15.0831 2.0138 15.0831 3.71674C15.0831 5.41967 13.6999 6.80292 11.9969 6.80292ZM11.9969 2.0138C11.0563 2.0138 10.294 2.77613 10.294 3.71674C10.294 4.65735 11.0563 5.41967 11.9969 5.41967C12.9376 5.41967 13.6999 4.65735 13.6999 3.71674C13.6999 2.77613 12.9376 2.0138 11.9969 2.0138Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M19.0915 6.79074C17.8312 6.79074 16.8046 5.76406 16.8046 4.50377C16.8046 3.24348 17.8312 2.2168 19.0915 2.2168C20.3518 2.2168 21.3785 3.24348 21.3785 4.50377C21.3785 5.76406 20.3518 6.79074 19.0915 6.79074ZM19.0915 3.60005C18.5936 3.60005 18.1878 4.0058 18.1878 4.50377C18.1878 5.00174 18.5936 5.40749 19.0915 5.40749C19.5895 5.40749 19.9953 5.00174 19.9953 4.50377C19.9953 4.0058 19.5895 3.60005 19.0915 3.60005Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M4.90892 6.79074C3.64863 6.79074 2.62195 5.76406 2.62195 4.50377C2.62195 3.24348 3.64863 2.2168 4.90892 2.2168C6.16922 2.2168 7.19589 3.24348 7.19589 4.50377C7.19589 5.76406 6.16922 6.79074 4.90892 6.79074ZM4.90892 3.60005C4.41095 3.60005 4.0052 4.0058 4.0052 4.50377C4.0052 5.00174 4.41095 5.40749 4.90892 5.40749C5.40689 5.40749 5.81264 5.00174 5.81264 4.50377C5.81264 4.0058 5.40689 3.60005 4.90892 3.60005Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M12.0031 19.363C11.9601 19.363 11.917 19.363 11.8801 19.363C9.36569 19.2954 7.31848 17.113 7.31848 14.494V10.1475C7.31848 9.25609 8.04392 8.5368 8.9292 8.5368H15.0647C15.9561 8.5368 16.6815 9.26224 16.6815 10.1537V14.6846C16.6815 15.9572 16.1774 17.1498 15.2676 18.0413C14.3823 18.902 13.2265 19.3692 12.0031 19.3692V19.363ZM8.9292 9.91391C8.8001 9.91391 8.69558 10.0184 8.69558 10.1475V14.494C8.69558 16.3691 10.1342 17.9306 11.9109 17.9798C12.8084 18.0228 13.6568 17.6724 14.3024 17.0453C14.9417 16.4183 15.2983 15.5822 15.2983 14.6846V10.1537C15.2983 10.0246 15.1938 9.92005 15.0647 9.92005H8.9292V9.91391Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M19.0913 17.6785C19.0544 17.6785 19.0237 17.6785 18.9868 17.6785C18.4765 17.6662 17.9785 17.5494 17.5113 17.3343C17.167 17.1744 17.0133 16.7625 17.1732 16.4182C17.333 16.074 17.7449 15.9203 18.0892 16.0801C18.3843 16.2154 18.6978 16.2891 19.0237 16.2953C19.6938 16.3076 20.3639 16.0617 20.8557 15.576C21.3475 15.0965 21.6242 14.451 21.6242 13.7624V10.0983C21.6242 10.0983 21.5996 10.043 21.5688 10.043H18.04C17.6589 10.043 17.3515 9.73561 17.3515 9.35444C17.3515 8.97328 17.6589 8.66589 18.04 8.66589H21.5688C22.3619 8.66589 23.0074 9.31141 23.0074 10.1045V13.7685C23.0074 14.8321 22.5894 15.8281 21.8271 16.5719C21.0893 17.2912 20.1241 17.6847 19.0974 17.6847L19.0913 17.6785Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M4.90869 17.6785C4.8718 17.6785 4.84106 17.6785 4.80418 17.6785C2.70164 17.6232 0.992554 15.7973 0.992554 13.6149V10.1045C0.992554 9.30526 1.63807 8.66589 2.43113 8.66589H5.95996C6.34112 8.66589 6.64851 8.97328 6.64851 9.35444C6.64851 9.73561 6.34112 10.043 5.95996 10.043H2.43113C2.43113 10.043 2.3758 10.0676 2.3758 10.0983V13.6087C2.3758 15.0534 3.4824 16.2523 4.84106 16.2891C5.22837 16.3014 5.60953 16.2215 5.95996 16.0617C6.30423 15.9018 6.71613 16.0555 6.87598 16.4059C7.03582 16.7502 6.87598 17.1621 6.5317 17.322C6.02144 17.5556 5.47428 17.6724 4.90869 17.6724V17.6785Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default Caregiver;
